class CustomAvailability extends HTMLElement {
  constructor(){
    super();

    const tags = this.dataset.tags;
    const selectedState = document.documentElement.dataset.stateSelected;
    if (!tags || !selectedState) return;

    let markup = `
      <span class="alert alert--note alert--circle alert--error">
        Available for delivery only
      </span>
    `;

    if(selectedState == 'VIC' && tags.includes(selectedState)) {
      markup = `
        <span class="alert alert--note alert--circle alert--success">
          Available for pick up & delivery
        </span>
      `;
    }

    this.innerHTML = markup;
  }
}
if (!customElements.get('custom-availability')){
  customElements.define('custom-availability', CustomAvailability);
}